module.exports = __webpack_public_path__ + "img/footer.a4d991ad.jpg";